import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SITE } from "@/data/content";
import { Seo } from "@/components/Seo";

const mapSrc =
  "https://www.google.com/maps?q=" +
  encodeURIComponent(SITE.address.full) +
  "&output=embed";

const Contact = () => (
  <div data-testid="contact-page" className="pt-20">
    <Seo
      title="Contact Us — Sober Life Foundation, Ulhasnagar"
      description="Reach Sober Life Foundation in Ulhasnagar. Call +91 75591 85591 or email soberlifefoundation23@gmail.com. Confidential consultation, open 24/7."
      path="/contact"
    />
    <section className="max-w-7xl mx-auto px-6 md:px-12 pt-20 md:pt-28 pb-16 md:pb-24 grid md:grid-cols-12 gap-14">
      <div className="md:col-span-6">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-teal mb-6">Contact Us</p>
          <h1 className="font-heading text-5xl md:text-7xl text-maroon-deep leading-[0.98]">
            We are here to listen.
          </h1>
          <p className="mt-7 max-w-md text-stone-600 text-lg leading-relaxed">
            Reaching out is the bravest first step. Our team responds with compassion and complete confidentiality —
            any time you're ready.
          </p>
        </Reveal>

        <div className="mt-12 space-y-8">
          <Reveal delay={0.05}>
            <a href={`tel:${SITE.phoneHref}`} data-testid="contact-phone" className="group block">
              <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-teal mb-2"><Phone size={14} /> Call Us</span>
              <span className="font-heading text-3xl md:text-4xl text-maroon-deep group-hover:text-sunrise transition-colors duration-300">{SITE.phone}</span>
            </a>
          </Reveal>
          <Reveal delay={0.1}>
            <a href={`mailto:${SITE.email}`} data-testid="contact-email" className="group block">
              <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-teal mb-2"><Mail size={14} /> Email Us</span>
              <span className="font-heading text-2xl md:text-3xl text-maroon-deep group-hover:text-sunrise transition-colors duration-300 break-all">{SITE.email}</span>
            </a>
          </Reveal>
          <Reveal delay={0.15}>
            <div data-testid="contact-address">
              <span className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-teal mb-2"><MapPin size={14} /> Visit Us</span>
              <address className="not-italic font-heading text-2xl md:text-3xl text-maroon-deep leading-snug">
                {SITE.address.lines.map((l) => (
                  <span key={l} className="block">{l}</span>
                ))}
              </address>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="flex items-center gap-2 text-stone-600">
              <Clock size={16} className="text-sunrise" /> Open 24 / 7 · Confidential Consultation
            </div>
          </Reveal>
        </div>
      </div>

      <div className="md:col-span-6">
        <Reveal delay={0.1}>
          <div className="overflow-hidden rounded-t-[3rem] rounded-b-2xl border border-stone-200 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
            <iframe
              title="Sober Life Foundation Location"
              data-testid="contact-map"
              src={mapSrc}
              className="w-full h-[420px] md:h-[560px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>

    <section className="bg-maroon py-16 md:py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <Reveal>
          <p className="font-heading italic text-3xl md:text-5xl text-cream leading-snug max-w-3xl mx-auto">
            "Because every life deserves a second chance."
          </p>
          <p className="mt-5 text-gold text-sm uppercase tracking-[0.22em]">Sober Life Foundation · Balkan Ji Bari Trust</p>
        </Reveal>
      </div>
    </section>
  </div>
);

export default Contact;
